<div *ngFor="let crumb of breadcrumbs;  let i = index;" class="crumb">
    <span class="crumb-label" (click)="navigate(crumb)"> 
        <span *ngIf="crumb.title" class="crumb-label-content" [class.actionable]="crumb.action">{{ crumb.title}}</span> 
    </span>
    <span *ngIf="i < breadcrumbs.length - 1" class="separator"> / </span>
</div>
